import Vue from "vue";
import Router from "vue-router";
/*import Home from "./views/Home.vue";*/
import Dash from "./components/Dash.vue";
import Nav from "./components/Nav.vue";
import Sites from "./components/Sites.vue";
import Reports from "./components/Reports.vue";
import Member from "./components/Member.vue";
import Help from "./components/Help.vue";
import Schedule from "./components/Schedule.vue";
import Feedback from "./components/Feedback.vue";
import Login from "./components/Login.vue";
import Home from "./components/Home.vue";
import Faq from "./components/Faq.vue";
import Submitted from "./components/Submitted.vue";
import Privacy from "./components/Privacy.vue";
import Damage from "./components/Damage.vue";
import About from "./components/About.vue";
import Process from "./components/Process.vue";
import Resilience from "./components/Resilience.vue";
import Wind from "./components/Wind.vue";
import Rain from "./components/Rain.vue";
import Storm from "./components/Storm.vue";
import Ancillary from "./components/Ancillary.vue";
import Registration from "./components/Registration.vue";
import Interest from "./components/Interest.vue";
import Guide from "./components/Guide.vue";
/*import InsMember from './components/InsMember.Vue'*/
import Inspections from "./components/Inspections.vue";
import InspectorLogin from "./components/InspectorLogin.vue";
import InspectorNav from "./components/InspectorNav.vue";
import InspectorResources from "./components/InspectorResources.vue";
import Training from "./components/Training.vue";
import Technical from "./components/Technical.vue";

Vue.use(Router);

export const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    /* This is the default project setup with views
   {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/!* webpackChunkName: "about" *!/ "./views/About.vue")
    }*/
    {
      path: "/nav",
      component: Nav,
      children: [
        {
          path: "/dash",
          component: Dash
        },
        {
          path: "/sites",
          component: Sites
        },
        {
          path: "/reports",
          component: Reports
        },
        {
          path: "/member",
          component: Member
        },
        {
          path: "/help",
          component: Help
        },
        {
          path: "/feedback",
          component: Feedback
        },
        {
          path: "/submitted",
          name: "Submitted",
          component: Submitted
        }
      ]
    },
    {
      path: "/ins-nav",
      component: InspectorNav,
      children: [
        {
          path: "/test",
          component: Training
        },
        {
          path: "/guide",
          component: Guide
        },
        {
          path: "/inspections",
          component: Inspections
        },
        {
          path: "/resources",
          component: InspectorResources
        } /*,
            {
                path: '/ins-member',
                component: InsMember
            }*/
      ]
    },
    {
      path: "/ins-login",
      name: "InspectorLogin",
      component: InspectorLogin
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: 'Strata Title Inspection Program ',
        metaTags: [
          {
            name: 'description',
            content: 'The home page of the North Queensland Strata Title Inspection Program'
          },
          {
            property: 'og:description',
            content: 'The home page of the North Queensland Strata Title Inspection Program'
          }
        ]
      }
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq
    },
    {
      path: "/agreement",
      name: "Privacy",
      component: Privacy
    },
    {
      path: "/damage",
      name: "Damage",
      component: Damage
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/process",
      name: "Process",
      component: Process
    },
    {
      path: "/resilience",
      name: "Resilience",
      component: Resilience
    },
    {
      path: "/wind",
      name: "Wind",
      component: Wind
    },
    {
      path: "/rain",
      name: "Rain",
      component: Rain
    },
    {
      path: "/storm",
      name: "Storm",
      component: Storm
    },
    {
      path: "/ancillary",
      name: "Ancillary",
      component: Ancillary
    },
    /*{
      path: "/registration",
      name: "Registration",
      component: Registration
    },*/
    {
        path: "/interest",
        name: "Interest",
        component: Interest
    },
    {
      path: "/estimating",
      name: "Estimating",
      component: Technical
    },
    { path: "*", redirect: "/" }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/ins-login", "/ancillary", "/storm",  "/rain", "/wind", "/resilience", "/process", "/about", "/damage", "/agreement", "/faq", "/", "/estimating", "/interest"];
  const insPages = ["/test", "/guide", "/inspections", "/resources"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = sessionStorage.getItem("token");

  if (authRequired && !loggedIn) {
    if(insPages.includes(to.path)){
        return next("/ins-login");
    }
    else {
        return next("/login");
    }
  }

  next();
});
